import { useUrlParameterFromRegex } from "@edreamsodigeo/frontend-core";
const useGetActionsFromUrl = () => {
  const tokenRegex = new RegExp(/.*actions=([^^,;:%?&]+).*?$/);
  const [, action] = useUrlParameterFromRegex(tokenRegex);
  return action;
};
export default useGetActionsFromUrl;